// A live video call keeps the élu present: the cross-origin Jitsi iframe swallows every
// pointer and key event the inactivity timer listens to. In-memory on purpose: unlike a
// DOM event, nothing outside the app bundle (extension, injected script) can fake it.
type PresenceListener = () => void;

const listeners = new Set<PresenceListener>();

export const signalSessionPresence = () => {
  listeners.forEach((listener) => listener());
};

export const onSessionPresence = (listener: PresenceListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
